import React, {useEffect, useMemo, useState} from 'react'
import {Dropdown, Tooltip, OverlayTrigger} from 'react-bootstrap'
import Select from 'react-select'
import {Formik, Form} from 'formik'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'

export type TimeOffUserFilterValues = {
  startDate: string
  endDate: string
  statuses: string[]
}

type Props = {
  initialValues: TimeOffUserFilterValues
  onApply: (values: TimeOffUserFilterValues) => void
  onReset: () => void
}

const statusOptions = [
  {value: 'Pending', label: 'Pending'},
  {value: 'Approved', label: 'Approved'},
  {value: 'Rejected', label: 'Rejected'},
  {value: 'Expired', label: 'Expired'},
]

const isAnyFilterSelected = (values: TimeOffUserFilterValues) =>
  Boolean(values.startDate || values.endDate || (values.statuses?.length ?? 0) > 0)

const TimeOffFilterDropdown: React.FC<Props> = ({initialValues, onApply, onReset}) => {
  const [showDropdownMenu, setShowDropdownMenu] = useState(false)
  const [isFilterApplied, setIsFilterApplied] = useState(false)

  useEffect(() => {
    setIsFilterApplied(isAnyFilterSelected(initialValues))
  }, [initialValues])

  const dropdownId = useMemo(() => `timeoff-user-filter-${Math.random().toString(36).slice(2)}`, [])

  return (
    <Dropdown onToggle={(next) => setShowDropdownMenu(next)}>
      <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-filter'>Filter</Tooltip>}>
        <Dropdown.Toggle
          variant='primary'
          id={dropdownId}
          className={`btn btn-icon btn-sm no-caret ${isFilterApplied ? 'btn-light-danger' : ''}`}
        >
          <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-primary' />
        </Dropdown.Toggle>
      </OverlayTrigger>

      {showDropdownMenu && (
        <Dropdown.Menu className='p-4 w-350px' align='end'>
          <div className='px-4 pb-4'>
            <div className='fs-4 text-dark fw-semibolder'>Filter</div>
          </div>

          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={(values, {setSubmitting}) => {
              setSubmitting(true)
              onApply(values)
              setSubmitting(false)
              setShowDropdownMenu(false)
            }}
          >
            {({values, setFieldValue, handleSubmit, resetForm, dirty, isSubmitting}) => (
              <Form
                onSubmit={(e: any) => {
                  e.preventDefault()
                  handleSubmit()
                }}
              >
                <div className='separator border-gray-200'></div>
                <div className='card px-4 mt-4'>
                  <div className='row flex-column'>
                    <div className='col-12 mb-3'>
                      <label className='form-label fs-7 mb-1'>Start Date</label>
                      <input
                        type='date'
                        className='form-control form-control-sm'
                        value={values.startDate || ''}
                        onChange={(e) => setFieldValue('startDate', e.target.value)}
                      />
                    </div>

                    <div className='col-12 mb-3'>
                      <label className='form-label fs-7 mb-1'>End Date</label>
                      <input
                        type='date'
                        className='form-control form-control-sm'
                        value={values.endDate || ''}
                        onChange={(e) => setFieldValue('endDate', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className='text-end pt-4 px-4'>
                  <button
                    type='button'
                    className='btn btn-sm btn-light me-2'
                    onClick={() => {
                      resetForm()
                      onReset()
                      setShowDropdownMenu(false)
                    }}
                  >
                    Reset
                  </button>
                  <button type='submit' className='btn btn-sm btn-primary' disabled={isSubmitting || !dirty}>
                    Apply
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}

export default TimeOffFilterDropdown


